export default __webpack_public_path__ + "static/store-manager-762aa66f4f97fc3822b88f0855b7005f.png";